var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "alerts-escalations" }, [
    _c("div", { staticClass: "chart-container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "alerts-summary" }, [
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(_vm.alertas, function (cantidad, tipo) {
            return _c("div", { key: tipo, staticClass: "col-md-3" }, [
              _c(
                "div",
                {
                  staticClass: "alert-summary-card",
                  class: _vm.getAlertClass(tipo),
                },
                [
                  _c("div", { staticClass: "alert-icon" }, [
                    _c("i", { class: _vm.getAlertIcon(tipo) }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "alert-content" }, [
                    _c("div", { staticClass: "alert-value" }, [
                      _vm._v(_vm._s(cantidad)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "alert-label" }, [
                      _vm._v(_vm._s(_vm.getAlertLabel(tipo))),
                    ]),
                  ]),
                ]
              ),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.alertas.vencidas > 0
        ? _c("div", { staticClass: "expired-alerts" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "expired-alerts-grid" }, [
              _c("div", { staticClass: "expired-alert-item" }, [
                _c("div", { staticClass: "expired-alert-header" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "expired-alert-content" }, [
                    _c("div", { staticClass: "expired-alert-title" }, [
                      _vm._v("Solicitudes Vencidas"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "expired-alert-count" }, [
                      _vm._v(_vm._s(_vm.alertas.vencidas) + " solicitudes"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "expired-alert-priority" }, [
                    _vm._v("URGENTE"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "expired-alert-description" }, [
                  _vm._v(
                    "\n            Solicitudes que han superado su fecha límite. Requieren resolución inmediata.\n          "
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.alertas.criticas > 0
        ? _c("div", { staticClass: "critical-alerts" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "critical-alerts-grid" }, [
              _c("div", { staticClass: "critical-alert-item" }, [
                _c("div", { staticClass: "critical-alert-header" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c("div", { staticClass: "critical-alert-content" }, [
                    _c("div", { staticClass: "critical-alert-title" }, [
                      _vm._v("Solicitudes Críticas"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "critical-alert-count" }, [
                      _vm._v(_vm._s(_vm.alertas.criticas) + " solicitudes"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "critical-alert-priority" }, [
                    _vm._v("CRÍTICO"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "critical-alert-description" }, [
                  _vm._v(
                    "\n            Solicitudes que requieren atención inmediata. Deben resolverse en las próximas horas.\n\n\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "critical-alert-description" }, [
                  _vm._v(
                    "\n            Solicitudes que vencen en las próximas 48 horas. Requieren atención prioritaria.\n          "
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "escalations-analysis" }, [
        _vm._m(5),
        _vm._v(" "),
        _c("div", { staticClass: "escalations-metrics" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-4" }, [
              _c("div", { staticClass: "escalation-metric-card" }, [
                _vm._m(6),
                _vm._v(" "),
                _c("div", { staticClass: "metric-content" }, [
                  _c("div", { staticClass: "metric-value" }, [
                    _vm._v(_vm._s(_vm.escalamientos.frecuencia_total || 17)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "metric-label" }, [
                    _vm._v("Total de Escalamientos"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "metric-subtitle" }, [
                    _vm._v("En el período"),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4" }, [
              _c("div", { staticClass: "escalation-metric-card" }, [
                _vm._m(7),
                _vm._v(" "),
                _c("div", { staticClass: "metric-content" }, [
                  _c("div", { staticClass: "metric-value" }, [
                    _vm._v(
                      _vm._s(
                        (_vm.escalamientos.tiempo_resolucion &&
                          _vm.escalamientos.tiempo_resolucion.promedio) ||
                          28
                      ) + "h"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "metric-label" }, [
                    _vm._v("Tiempo Promedio de Resolución"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "metric-subtitle" }, [
                    _vm._v("Después del escalamiento"),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4" }, [
              _c("div", { staticClass: "escalation-metric-card" }, [
                _vm._m(8),
                _vm._v(" "),
                _c("div", { staticClass: "metric-content" }, [
                  _c("div", { staticClass: "metric-value" }, [
                    _vm._v(
                      _vm._s(
                        Object.keys(_vm.escalamientos.patrones_agente || {})
                          .length || 1
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "metric-label" }, [
                    _vm._v("Agentes con Escalamientos"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "metric-subtitle" }, [
                    _vm._v("Requieren apoyo"),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [
      _c("i", { staticClass: "fal fa-exclamation-triangle text-danger" }),
      _vm._v(" Alertas y Escalamientos"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h6", [
      _c("i", { staticClass: "fal fa-times-circle text-danger" }),
      _vm._v(" Alertas Vencidas"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "expired-alert-icon" }, [
      _c("i", { staticClass: "fal fa-calendar-times text-danger" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h6", [
      _c("i", { staticClass: "fal fa-exclamation-triangle text-warning" }),
      _vm._v(" Alertas Críticas"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "critical-alert-icon" }, [
      _c("i", { staticClass: "fal fa-exclamation-triangle text-warning" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h6", [
      _c("i", { staticClass: "fal fa-level-up-alt text-warning" }),
      _vm._v(" Análisis de Escalamientos"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "metric-icon text-primary" }, [
      _c("i", { staticClass: "fal fa-chart-line" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "metric-icon text-warning" }, [
      _c("i", { staticClass: "fal fa-stopwatch" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "metric-icon text-info" }, [
      _c("i", { staticClass: "fal fa-users" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }